export default "__VITE_ASSET__C$0UqH$d__"